// eslint-disable-next-line import/prefer-default-export
export const UPDATE_PUBLISHER_RECORD = 'actionId/UPDATE_PUBLISHER_RECORD'
